import {Component, OnInit, ViewChild} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {KeycloakProfile} from 'keycloak-js';
import {
  NgbCollapse,
  NgbDropdown,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbTooltip
} from '@ng-bootstrap/ng-bootstrap';
import {RolesService} from '../../../services/roles.service';
import {RouterLink, RouterLinkActive} from "@angular/router";
import {NavbarComponent} from "../navbar/navbar.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {CommonModule} from "@angular/common";
import {SpinnerComponent} from "../../common/spinner/spinner.component";
import {FaqCategory} from "../../../model/FaqCategory";
import {HttpClient} from "@angular/common/http";

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    imports: [
        CommonModule,
        RouterLink,
        NavbarComponent,
        FaIconComponent,
        NgbDropdown,
        SpinnerComponent,
        NgbCollapse,
        RouterLinkActive,
        NgbTooltip,
        NgbDropdownToggle,
        NgbDropdownMenu,
        NgbDropdownItem
    ],
    styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {
  profile: Promise<KeycloakProfile>;
  @ViewChild('dropdown') dropdown: NgbDropdown;
  allowedRnProducts: FaqCategory[] = [];
  hideBurger = true;

  constructor(public keycloakService: KeycloakService, public rolesService: RolesService, private http: HttpClient) {
  }

  ngOnInit(): void {
    this.profile = this.keycloakService.loadUserProfile(false);
    this.http.get<FaqCategory[]>("/api/v1/rn").subscribe(r => {
      this.allowedRnProducts = r.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    });
  }

  logout(): void {
    this.keycloakService.logout();
  }

  onHover(): void {
    this.dropdown.toggle();
  }


}
